import {format, parseISO, startOfWeek} from 'date-fns';

import {CheckInCheckInQuestionFragment, Maybe} from '#apollo/schema';
import {getFormattedDateRange} from '#util';

/**
 * Returns an array of questions that include a `healthFactor`, and to which the
 * user responded positively (ie, the `answerBoolean` field is `true`).
 */
export const getAchievedActionableQuestions = (questions: CheckInCheckInQuestionFragment[] = []) =>
  questions.filter(({healthFactor, answerBoolean}) => !!healthFactor && !!answerBoolean);

/**
 * Returns an array of questions that include a `healthFactor`, and to which the
 * user responded negatively (ie, the `answerBoolean` field is `false`).
 */
export const getUnachievedActionableQuestions = (
  questions: CheckInCheckInQuestionFragment[] = [],
) => questions.filter(({healthFactor, answerBoolean}) => !!healthFactor && !answerBoolean);

/**
 * Returns a string representing the date range in which the current CheckIn may
 * be completed. The end date is offset to be the Sunday before the next CheckIn
 * starts.
 */
export const getFormattedCheckInDateRange = (startedOn = '', endedOn = '') =>
  !!(startedOn && endedOn)
    ? getFormattedDateRange(startedOn, format(startOfWeek(parseISO(endedOn)), 'yyyy-MM-dd'))
    : '';

/**
 * Returns a string representing the date in which the earliest CheckIn may
 * start for the current TestPeriod.
 */
export const getFormattedEarliestCheckInDate = (earliestStartedOn: Maybe<string> = '') =>
  earliestStartedOn ? format(parseISO(earliestStartedOn), 'EEEE, MMMM d') : '';
